import {HttpInterceptorFn} from '@angular/common/http';
import {inject, PLATFORM_ID} from '@angular/core';
import {StorageService} from '../services/storage-service';
import {AuthService} from '../services/auth';
import {isPlatformServer} from '@angular/common';

export const prefixInterceptor: HttpInterceptorFn = (req, next) => {
  let storageService = inject(StorageService);
  let authService = inject(AuthService);
  let platformId = inject(PLATFORM_ID);
  let newRequest = req.clone({
    url: ((isPlatformServer(platformId)) ? 'https://apnerishte.com' : '') + '/api/' + req.url,
    withCredentials: true,
  })
  return next(newRequest);
};
